import { CustomActions, CustomState } from "@gerrieDev/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useState } from "react";
import { connect, DispatchProp } from "react-redux";
import { css } from "styled-components";
import Search from "@insite/mobius/Icons/Search";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import TextField from "@insite/mobius/TextField";

const alphabetArr = [
    'A', 'B', 'C', 'D', 'E', 'F',
    'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z'
  ]

const filterDiv = {
    css: css`
        margin-top: 1rem;
        button{
            border: 1px solid black !important;
            background: transparent !important;
        }
        dd{
            border: none !important;
            padding: 0 !important;
            padding-top: 1rem !important;
            span{
                display: inline-block;
                width: 16%;
                text-align: center;
            }
        }
    `
}

const searchTextField = {
    css : css`
        border: 1px solid black;
        button{
            background-color: #016EAF;
            span{
                background: #016EAF !important;
                svg{
                    color: white
                }
            }
        }
    `
}

type Props = DispatchProp<CustomActions>;

const FilterManufacturer: React.FC<Props> = ({ dispatch }: Props) => {
   const [filterStr, setFilterStr] = useState('');

   const filterHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilterStr(event.target.value);
    };


 
    return (
        <StyledWrapper>
            <StyledWrapper {...searchTextField}>
                <TextField
                    iconProps={{src: Search}}
                    iconClickableProps={{ 
                        onClick: () => {
                            dispatch({ type: "Custom/SearchManufacturer", manufacturer: filterStr.toLocaleLowerCase() })                            } 
                    }}
                    placeholder="Manufacturer Name"
                    onChange={filterHandler}
                />
</StyledWrapper>
            <StyledWrapper {...filterDiv}>
                    <Accordion headingLevel={5}>
                        <AccordionSection title="Filter by Alphabet">
                                    {alphabetArr.map(i => 
                                        <span style={{color: '#016EAF', cursor: "pointer"}}
                                            onClick={ () => dispatch({ type: "Custom/SearchManufacturer", manufacturer: i.toLocaleLowerCase() })}
                                        >
                                            {i}
                                        </span>
                                    )}
                        </AccordionSection>
                    </Accordion>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(FilterManufacturer),
    definition: {
        group: "Basic",
        icon: "Link",
        fieldDefinitions: [
        ],
    },
};

export default widgetModule;
